import React from 'react';
import styled from 'styled-components';

const MapContent = styled.main`
    z-index: 0;
    grid-column: page-start / page-end;
    grid-row: header-bottom / page-bottom;
`;

export default MapContent;
